module.exports = __webpack_public_path__ + "img/austria.47064838.svg";